export const retrieveOtherStatesService = async (payload: any) => {
    try {
        const response = await fetch(`https://countriesnow.space/api/v0.1/countries/states`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        });
        const res = await response.json();
        if (!response.ok) {
            console.error('Error:', res);
            throw new Error(res.message);
        };
        return res;
    } catch (error) {
        console.error('API fetch error:', error);
        throw error;
    }
};
